<template>
  <div class="head-bar-container" @click.self="closeMenu">
    <div class="head-bar-row pc_padding">
      <a class="head-bar-name-row cursor" :href="getHref('/')">
        <div class="head-bar-name">
          {{ title }}
        </div>
      </a>
      <div class="head-bar-btns-row">
        <a v-if="domainConfig?.novel == 1" class="head-bar-novel-btn cursor" :href="getHref('/novel')">
          <img src="@/assets/novel-icon.png" alt=""> <span
            v-if="deviceType != 'mobile'">Novel</span>
        </a>
        <div class="head-bar-hamber-row cursor" @click="toggleOpenState">
          <img src="@/assets/menu.png" alt="">
        </div>
      </div>
    </div>

    <div class="menu" :class="{ 'menu-open': isOpen }">
      <div class="menu-title">
        Resources
      </div>
      <ul>
        <li class="cursor">
          <a :href="getHref('/')" @click="isOpen = false">Home</a>
          <div class="arrow" />
        </li>
        <li class="cursor">
          <a :href="getHref('/terms-of-services')" @click="isOpen = false">Terms of services</a>
          <div class="arrow" />
        </li>
        <li class="cursor">
          <a :href="getHref('/privacy-policy')" @click="isOpen = false">Privacy policy</a>
          <div class="arrow" />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    title: {
      type: String,
      required: true
    },
  },
  data () {
    return {
      isOpen: false,
    }
  },
  computed: {
    ...mapGetters([
      'deviceType',
      'domainConfig'
    ])
  },
  mounted () {
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy () {
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    getHref (path) {
      const currentParams = this.$router.currentRoute.params; // 当前路由的 params
      const currentQuery = this.$route.query; // 当前路由的 query

      const channel = currentParams.channel ? `/${currentParams.channel}` : ''; // 拼接 channel path
      const queryString = new URLSearchParams(currentQuery).toString(); // 转换 query 对象为字符串
      const fullQueryString = queryString ? `?${queryString}` : ''; // 如果有查询参数，拼接为 ?xxx=yyy 格式
      return `${channel}${path}${fullQueryString}`;
    },
    toggleOpenState () {
      this.isOpen = !this.isOpen;
    },
    handleClickOutside (event) {
      if (this.isOpen && !this.$el.contains(event.target)) {
        this.isOpen = false;
      }
    },
    closeMenu () {
      if (this.isOpen) {
        this.isOpen = false;
      }
    },
  },
}
</script>
